import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const metadataFormSlice = createSlice({
  name: "metadataForm",
  initialState: initialState,
  reducers: {
    updateForm: (state, param) => {
      const { payload } = param;
      for (const [k, v] of Object.entries(payload)) {
        state[k] = v;
      }
    },
    resetForm: () => initialState,
  },
});

// Action creators are generated for each case reducer function
const { actions, reducer } = metadataFormSlice;
export const { updateForm, resetForm } = actions;

export default reducer;
